export default __webpack_public_path__ + "./images/bo.1c294e88.png";